<template>
    <el-dialog :visible.sync="show.state" :modal-append-to-body="true" center title="地图选点">
        <div>
            <div>
              <span>经度：</span>
              <span style="margin-left:10px">度&nbsp;&nbsp;数:
                <el-input type="number" step="1" style="width:20%" size="small" v-model="latlng.lng" placeholder="经度" @change="changeLatlng"></el-input>
              </span>
              <span style="margin-left:10px">度分秒:
                <el-input type="number" step="1" style="width:10%" size="small" v-model="dms.lng.degree" placeholder="度" @change="changeDMS"></el-input>°
                <el-input type="number" step="1" style="width:10%" size="small" v-model="dms.lng.minute" placeholder="分" @change="changeDMS"></el-input>'
                <el-input type="number" step="1" style="width:10%" size="small" v-model="dms.lng.second" placeholder="秒" @change="changeDMS"></el-input>"
              </span>
            </div>
            <div>
              <span>纬度：</span>
              <span style="margin-left:10px">度&nbsp;&nbsp;数:
                <el-input type="number" step="1" style="width:20%" size="small" v-model="latlng.lat" placeholder="经度" @change="changeLatlng"></el-input>
              </span>
              <span style="margin-left:10px">度分秒:
                <el-input type="number" step="1" style="width:10%" size="small" v-model="dms.lat.degree" placeholder="度" @change="changeDMS"></el-input>°
                <el-input type="number" step="1" style="width:10%" size="small" v-model="dms.lat.minute" placeholder="分" @change="changeDMS"></el-input>'
                <el-input type="number" step="1" style="width:10%" size="small" v-model="dms.lat.second" placeholder="秒" @change="changeDMS"></el-input>"
              </span>
            </div>
        </div>
        <div class="tips">提示：可手动输入经纬度，或者在地图中点击鼠标右键选址</div>
        <div style="width:100%;height:400px">
            <marker-map ref="map" :tileLayers="tileLayers" :location.sync="location" style="height:400px;"></marker-map>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button native-type="submit" type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import Utils from '@/data/utils.js'
export default {
    props: {
        show: {},
        source: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    data() {
        return {
            tileLayers: [
                {
                    id: 0,
                    name: "影像",
                    url: "http://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}&lang=zh_cn",
                    options: {
                        subdomains: ["1", "2", "3", "4"]
                    }
                },
                {
                    id: 1,
                    name: "地名标注",
                    url: "http://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}&lang=zh_cn",
                    options: {
                        subdomains: ["1", "2", "3", "4"]
                    }
                }
            ],
            location: [39.9181370976, 116.3002283764],
        };
    },
    watch: {
        source() {
            if (this.source == null) {
                return;
            }
            this._loadLocation();
        }
    },
    created() {
        this._loadLocation();
    },
    methods: {
        _loadLocation() {
            if (this.source && this.source.lat && this.source.lng) {
                this.location = [this.source.lat, this.source.lng];
            }else{
                this.location = [39.9181370976, 116.3002283764]
            }
        },
        //执行确认操作
        confirm() {
            if(this.latlng.lat > 90 || this.latlng.lat <0 || this.latlng.lng > 180 || this.latlng.lng < 0){
                this.$message({type: "error", message: "经纬度值异常，请检查！"});
                return;
            }
            this.$emit("change", this.latlng, this.dms);
            this.cancel();
        },
        // 关闭回调
        cancel() {
            this.show.state = false;
        },
        changeLatlng(val) {
            this.location = [this.latlng.lat, this.latlng.lng];
        },
        changeDMS(val) {
            this.location = [
                Utils.change2D(this.dms.lat),
                Utils.change2D(this.dms.lng)
            ];
        },
    },
    computed: {
        latlng() {
            return {
                lat: this.location[0],
                lng: this.location[1]
            };
        },
        dms() {
            return {
                lat: Utils.change2Dms(this.location[0]),
                lng: Utils.change2Dms(this.location[1])
            };
        }
    },

  mounted() {
    const self = this;
    document.body.appendChild(self.$el);
    self.$el.classList.add("map-dialog-wrap");
  }
};
</script>

<style lang="stylus" scoped>
.tips {
    color:#999999;
}
</style>



// WEBPACK FOOTER //
// MapPointer.vue?b5e90284